import { defineStore } from 'pinia';
import { FundraisingDetail } from '@/models/fundraising-detail.model';
import { FundraisingDonationModel } from '@/models/fundraising-donation.model';
import {
  initialValuesProjectDonationsPagination,
  FundraisingDonationsPagination
} from '@/models/fundraising-donations-pagination.model';
import { fundraisingProjectDonations } from '@/services/session/details.service';

interface FundraisingDetailStore {
  loaded: boolean;
  loading: boolean;
  detail: FundraisingDetail;
  donations: FundraisingDonationModel[];
  projectDetailDonationsPagination: FundraisingDonationsPagination;
}

export const useFundraisingDetailStore = defineStore('detail', {
  state: (): FundraisingDetailStore => {
    return {
      loaded: false,
      loading: false,
      detail: {} as FundraisingDetail,
      donations: [] as FundraisingDonationModel[],
      projectDetailDonationsPagination: initialValuesProjectDonationsPagination,
    } as FundraisingDetailStore;
  },
  getters: {
    getId: (state) => state.detail.id,
    getTitle: (state) => state.detail.title,
    getDonations: (state) => state.donations,
    getProjectDetailPagination: (state) => state.projectDetailDonationsPagination
  },
  actions: {
    setProjectDonations(donations: FundraisingDonationModel[]) {
      this.$patch ({
      donations: donations
    })
  },
    resetProjectDetailPagination() {
      this.$patch({
        donations: [] as FundraisingDonationModel[],
        projectDetailDonationsPagination: {
          total: 0,
          sort: undefined,
          page: 0,
          pageSize: 10,
        } as FundraisingDonationsPagination,
      });
    },
    setPaginationTotal(value: number) {
      const pagination = this.getProjectDetailPagination;
      this.$patch({
        projectDetailDonationsPagination: {
          ...pagination,
          ...{
            total: value,
          },
        },
      });
    },
    setPaginationPageSize(value: number) {
      const pagination = this.getProjectDetailPagination;
      this.$patch({
        projectDetailDonationsPagination: {
          ...pagination,
          ...{
            pageSize: value,
          },
        },
      });
      fundraisingProjectDonations(this.detail.id);
    },
    setPaginationPage(value: number) {
      const pagination = this.getProjectDetailPagination;
      this.$patch({
        projectDetailDonationsPagination: {
          ...pagination,
          ...{
            page: value,
          },
        },
      });
      fundraisingProjectDonations(this.detail.id);
    },
    setPaginationSort(value: string) {
      const pagination = this.getProjectDetailPagination;
      this.$patch({
        projectDetailDonationsPagination: {
          ...pagination,
          ...{
            sort: value,
          },
        },
      });
      fundraisingProjectDonations(this.detail.id);
    },
  },
});
